// extracted by mini-css-extract-plugin
export default {"container":"agent_container__QT95o","--human":"agent_--human__CPytP","text-separator":"agent_text-separator__oqU7+"};